import {DetailsViewUiConfig, IDocMapping} from '@stores/config'
import { IEditableCallback } from './ui'

export * from './ui'

/**
 * Workspace -> Dictionary of es-index -> configuration
 * Can be overridden at the individual workspace level
 */
export type DetailsViewsByIndex = {
  [esIndex: string]: DetailsViewConfig
}

/**
 * The details view for a given catalog or library item
 *
 * Examples:
 *    A modal view of the MPV when in the Merchanding board
 *    A sidebar view of the same when drilling down into the libraries view
 */
export type DetailsViewConfig = DetailsViewUiConfig & {
  // id?: string

  syncId?: string
  docMapping?: IDocMapping

  allow?: {uploadImages?: IEditableCallback}
  /**
   * switch to:
   * ui: {
   *   modal sidebar
   * }
   * server: {
   *   syncId, docMapping (rename to mapping)
   * }
   */
}



// WEBPACK FOOTER //
// ./src/stores/config/deployment/detailsView/index.ts